export const iconNames = [
  "accessibility",
  "add",
  "add-app",
  "add-app-filled",
  "add-filled",
  "add-to-cart",
  "addon",
  "afternic",
  "afternic-domaining",
  "album-contacts",
  "album-contacts-filled",
  "alert",
  "align-center",
  "align-justify",
  "align-left",
  "align-right",
  "all-paytools",
  "all-saleschannels",
  "amazon",
  "android",
  "app-center",
  "apple",
  "appointments",
  "apps",
  "apps2",
  "apps2-filled",
  "archive",
  "archlinux",
  "arrow-down",
  "arrow-left",
  "arrow-right",
  "arrow-up",
  "arrows-circle",
  "arrows-circle-filled",
  "at",
  "attachment",
  "auction",
  "auction-filled",
  "backspace",
  "backward",
  "bag",
  "bag-favorite",
  "bag-favorite-filled",
  "bar-graph",
  "barcode",
  "bell",
  "benefits",
  "benefits-filled",
  "binoculars",
  "blackberry",
  "blog",
  "blogger",
  "bluetooth",
  "bold",
  "bookmark",
  "briefcase",
  "briefcase-filled",
  "bulleted-list",
  "bulleted-list-filled",
  "bullseye",
  "calculator",
  "calendar",
  "calendar-filled",
  "camera",
  "cart",
  "centos",
  "chat",
  "checkbox",
  "checkbox-filled",
  "checkbox-list",
  "checkbox-list-filled",
  "checkmark",
  "chevron-dbl-left",
  "chevron-dbl-right",
  "chevron-down",
  "chevron-left",
  "chevron-right",
  "chevron-up",
  "circle",
  "circle-filled",
  "circle-half",
  "clear-formatting",
  "click",
  "clipboard",
  "clock",
  "cloud",
  "cloud-upload",
  "code",
  "color-palette",
  "columns",
  "comment",
  "comments",
  "content",
  "conversations",
  "conversations-filled",
  "copy",
  "core-os",
  "corners-rounded",
  "corners-sharp",
  "create-button",
  "create-form",
  "create-nav",
  "credit-card",
  "crop",
  "crosshair",
  "currency",
  "cut",
  "dashboard",
  "dashboard-filled",
  "database",
  "database-network",
  "deals",
  "debian",
  "delete",
  "desktop",
  "diamond",
  "discount",
  "divide",
  "dollar",
  "domain",
  "donate",
  "download",
  "draw",
  "drive",
  "dropdown-menu",
  "ebay",
  "edit",
  "editor-larger",
  "editor-smaller",
  "eject",
  "ellipsis",
  "email",
  "etsy",
  "euro",
  "excel",
  "exchange",
  "experiment",
  "experiment-filled",
  "eye-dropper",
  "facebook",
  "faqs",
  "fast-backward",
  "fast-forward",
  "fast-forward-1",
  "feature",
  "fedora",
  "filter",
  "fingerprint",
  "fire",
  "flag",
  "flatrate",
  "folder",
  "folder-add",
  "folder-filled",
  "folder-minus",
  "folder-network",
  "folder-open",
  "fonts-pairing",
  "food",
  "forward",
  "gallery",
  "gd-logo",
  "gd-logo-text",
  "gd-the-go",
  "gift",
  "google",
  "google-shopping",
  "grab-vert",
  "graph",
  "group",
  "hamburger",
  "handicap",
  "handicap-filled",
  "heart",
  "heart-filled",
  "help",
  "hide",
  "history",
  "home",
  "home-filled",
  "horizontal-spacing",
  "image",
  "image-gallery",
  "in-person",
  "inbox",
  "inbox-full",
  "indent-left",
  "indent-right",
  "information",
  "inline-edit",
  "instagram",
  "intro",
  "invoice",
  "invoice-filled",
  "invoices",
  "italic",
  "items-align-center",
  "items-align-left",
  "items-align-right",
  "layers",
  "layers-filled",
  "layout",
  "leaf",
  "lightbulb",
  "lightning-bolt",
  "line",
  "link",
  "link-arrow",
  "linkedin",
  "location",
  "locked",
  "locu",
  "logout",
  "mail",
  "mail-filled",
  "mail-lock",
  "mail-open",
  "mail-open-filled",
  "map",
  "map-pin",
  "marketing",
  "marketplaces",
  "media",
  "megaphone",
  "megaphone-filled",
  "menu",
  "messenger",
  "meta",
  "mic",
  "microsoft-teams",
  "minus",
  "mobile-phone",
  "moon",
  "network",
  "no",
  "numbered-list",
  "offerup",
  "office-365",
  "ok",
  "ok-filled",
  "online-ordering",
  "online-store",
  "orders",
  "orders-filled",
  "outlook",
  "page",
  "pages",
  "paint-bucket",
  "paintbrush",
  "pause",
  "pay-links",
  "pay-links-filled",
  "pay-links-wallet",
  "payouts",
  "payouts-filled",
  "paypal",
  "percent",
  "phone",
  "picasa",
  "pin",
  "pintrest",
  "play",
  "plus",
  "pound",
  "powerpoint",
  "print",
  "privacy",
  "products",
  "products-filled",
  "qrcode",
  "qrcode-filled",
  "quote",
  "random",
  "receipt",
  "reciept-ok",
  "redo",
  "refresh",
  "refresh-off",
  "remove",
  "reply",
  "reply-all",
  "reports",
  "reports-filled",
  "resize",
  "retweet",
  "revert",
  "safety",
  "save",
  "scanner",
  "search",
  "search-bulk",
  "select",
  "send",
  "server",
  "service-bell",
  "service-bell-filled",
  "settings",
  "settings-filled",
  "settlements",
  "settlements-filled",
  "shape-3-round",
  "shape-beveled",
  "shape-beveled-left",
  "shape-beveled-right",
  "shape-circle",
  "shape-curved-left",
  "shape-curved-right",
  "shape-leaf",
  "shape-pill",
  "shape-rectangle-landscape",
  "shape-rectangle-pano",
  "shape-rectangle-portrait",
  "shape-square",
  "shape-window",
  "shapes",
  "share",
  "shield",
  "shield-check",
  "shield-check-filled",
  "shipping",
  "shipping-scale",
  "shipping-scale-filled",
  "show",
  "sidebar-collapse",
  "sidebar-collapse-filled",
  "sidebar-expand",
  "sidebar-expand-filled",
  "sliders",
  "sm-business",
  "sm-business-filled",
  "smart-terminal",
  "social",
  "spacing",
  "spacing-col",
  "sparkles",
  "sparkles-filled",
  "speedometer",
  "ssl",
  "star",
  "star-filled",
  "star-half",
  "step-backward",
  "step-backwards",
  "step-forward",
  "stop",
  "strike-through",
  "styles",
  "subscript",
  "sun",
  "superscript",
  "table",
  "tablet",
  "tabs",
  "tabs-filled",
  "tag",
  "tag-filled",
  "text-highlight",
  "text-tool",
  "thumbs-down",
  "thumbs-up",
  "thumbs-up-filled",
  "thunderbird",
  "tiktok",
  "transactions",
  "trash",
  "truck",
  "tumblr",
  "twitter",
  "ubuntu",
  "umbrella",
  "underline",
  "undo",
  "unlink",
  "unlocked",
  "upload",
  "user",
  "user-add",
  "user-circle",
  "user-circle-filled",
  "user-delete",
  "user-heart",
  "user-heart-filled",
  "user-locked",
  "user-locked-filled",
  "user-remove",
  "user-unlocked",
  "user-unlocked-filled",
  "user-waving",
  "user-waving-filled",
  "users2",
  "users3",
  "vertical-spacing",
  "video",
  "video-camera",
  "virtual-terminal",
  "virtual-terminal-filled",
  "volume-down",
  "volume-mute",
  "volume-up",
  "walmart",
  "wand",
  "wand-filled",
  "website",
  "website-filled",
  "wechat",
  "weight",
  "weight-filled",
  "whatsapp",
  "wi-fi",
  "window-new",
  "windows",
  "word",
  "wordpress",
  "world",
  "world-filled",
  "x",
  "x-thick",
  "yahoo",
  "yelp",
  "youtube"
] as const;

export default iconNames;
